import { ApiResponse } from '@/types';

import { IDropdownSearchResponse } from '@/components/common/DropdownSearch/DropdownSearch.interfaces';
import { ITableCellStatus, ITableCellTag } from '@/components/common/Table/Table.interfaces';

import { IIpadSerialNumberSearchResponse } from '@/features/ipad-configs/interfaces';
import { AccessControlMode, DeviceType } from '@/features/ipad-configs/enums';
import { ComponentType } from 'react';
import { LogIn01Icon, Shield03Icon } from '@/assets/icons';

export const getDeviceTypeLabel = (status: DeviceType): string => {
  switch (status) {
    case DeviceType.OfficeCheckIn:
      return 'Office check-in';
    case DeviceType.MeetingRoom:
      return 'Meeting room';
    case DeviceType.ProjectRoom:
      return 'Project room';
    case DeviceType.NotInUse:
      return 'Not in use';
  }
};

export const getDeviceTypeVariant = (status: DeviceType): ITableCellTag['tagVariant'] => {
  switch (status) {
    case DeviceType.NotInUse:
      return 'notInUse';
    case DeviceType.MeetingRoom:
      return 'meetingRoom';
    case DeviceType.ProjectRoom:
      return 'projectRoom';
    case DeviceType.OfficeCheckIn:
      return 'officeCheckIn';
    default:
      return 'default';
  }
};

export const mapSerialNumberResponseToDropdownSearchResponse = (
  response: ApiResponse<IIpadSerialNumberSearchResponse>,
): IDropdownSearchResponse => {
  return {
    data: response.data.data.map((item) => ({
      value: item.serialNumber,
      label: item.serialNumber,
      cursor: item.id,
    })),
    cursor: response.data.metadata?.cursor,
  };
};

export const getAccessControlModeLabel = (mode?: AccessControlMode): string => {
  switch (mode) {
    case AccessControlMode.OpenAccess:
      return 'Open Access';
    case AccessControlMode.RestrictedAccess:
      return 'Restricted Access';
    default:
      return 'Unknown';
  }
};

export const getAccessControlModeIcon = (
  mode?: AccessControlMode,
): ComponentType<{ className?: string }> => {
  switch (mode) {
    case AccessControlMode.OpenAccess:
      return LogIn01Icon;
    case AccessControlMode.RestrictedAccess:
      return Shield03Icon;
    default:
      return LogIn01Icon;
  }
};

export const getAccessControlModeVariant = (
  mode?: AccessControlMode,
): ITableCellStatus['statusVariant'] => {
  switch (mode) {
    case AccessControlMode.OpenAccess:
      return 'completed';
    case AccessControlMode.RestrictedAccess:
      return 'todo';
    default:
      return 'completed';
  }
};
